import { ElementTypeEnum, getElementTypeFromString } from "../../elementTypeMappings";
import DoorData from "./DoorData";
import SpaceData from "./SpaceData";
import ProductData from "../../model/productData/ProductData";
import CoveringData from "./CoveringData";

export const buildProductData = (input : {productType: string}) => {
    
    const elementType = getElementTypeFromString(input.productType);

    switch (elementType) {
        case ElementTypeEnum.Door:
            return DoorData.fromJSON(input);
        case ElementTypeEnum.Space:
            return SpaceData.fromJSON(input);
        case ElementTypeEnum.Covering:
            return CoveringData.fromJSON(input);

        default:
            return ProductData.fromJSON(input);
    }
};